import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";
import routerConstant from "service/constant/routerConstant";
import type { ICasesList } from "service/interface/cases";

interface Props {
  data: ICasesList[];
}

export function CasesListTable({ data }: Props) {
  const navigate = useNavigate();

  const handleTableClick = (id: number) => {
    navigate(`${routerConstant.CASES.index}/${id}`);
  };

  return (
    <div className="w-ful">
      <table className="w-full divide-y divide-[#d1dff3]">
        <thead>
          <tr>
            <th
              scope="col"
              className="min-w-[55px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
            >
              ID
            </th>
            <th
              scope="col"
              className="min-w-[160px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
            >
              카테고리
            </th>
            <th
              scope="col"
              className="min-w-[240px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
            >
              전 사진
            </th>
            <th
              scope="col"
              className="min-w-[240px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
            >
              후 사진
            </th>
            <th
              scope="col"
              className="min-w-[218px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
            >
              제목
            </th>
            <th
              scope="col"
              className="min-w-[120px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
            >
              생성일
            </th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {data.map((cases) => (
            <tr
              key={cases.id}
              className="cursor-pointer even:bg-[#fbfbfb] hover:bg-blue-2"
              onClick={() => handleTableClick(cases.id)}
            >
              <td className="whitespace-nowrap px-[15px] py-[16px] text-M1 text-gray-5">
                {cases.id}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                {cases.category}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                <img
                  src={cases.beforeImgSrc}
                  alt="img"
                  className="h-[120px] w-[200px] object-cover"
                />
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-left text-M1 text-gray-5">
                <img
                  src={cases.afterImgSrc}
                  alt="img"
                  className="h-[120px] w-[200px] object-cover"
                />
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                {cases.title}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                {moment(cases.createdAt).format("YYYY-MM-DD")}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
